import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { toggleReviewLike } from '../actions/reviews.actions';
import { cookieService } from "../services";
import LoginModal from './tailwind/LoginModal';
import { formatDate } from '../utils/formatters.util';
import StarRating from './StarRating';
import CookieNames from '../constants/cookie-names.constants';

const ProductReviewsItem = ({ review, imagesShown, toggleModalHandler }) => {
  const loginModalRef = useRef(null);
  const dispatch = useAppDispatch();

  const { likedReviewIds } = useSelector((state) => state.likedReviews);
  const { locallyChanged } = useSelector((state) => state.reviewsLikeToggle);

  const [showLoginModal, setShowLoginModal] = useState(false);

  const toggleLikeHandler = useCallback(() => {
    if (cookieService.get(CookieNames.NAME)) {
      dispatch(toggleReviewLike(review.id));
    } else if (showLoginModal) {
      loginModalRef.current.openModal();
    } else {
      setShowLoginModal(true);
    }
  }, [dispatch, review, showLoginModal]);

  const isLiked = useMemo(() => likedReviewIds.indexOf(review.id) >= 0, [likedReviewIds, review]);
  const reviewLikes = useMemo(
    () =>
      review.likesCount +
      locallyChanged.filter((i) => i.id === review.id).reduce((acc, item) => (acc + item.value ? 1 : -1), 0),
    [review, locallyChanged]
  );

  return (
    <React.Fragment>
      <div className='product-review'>
        <div>
          <StarRating reviewRating={review.rating} hideLabels />
          <span>{formatDate(review.created)}</span>
        </div>

        <p className='product-review__title'>{review.title}</p>
        <p className='product-review__author'>by {review.author}</p>
        {/* Commented till we have attributes prop */}
        {/* <ul className='product-review__variant'>
        <li>
          <label>Size: </label>
          <span>{review.size}</span>
        </li>
        <li>
          <label>Color: </label>
          <span>{review.color}</span>
        </li>
      </ul> */}
        <p className='product-review__description'>{review.body}</p>
        {/* Hide images temporarily */}
        {false && imagesShown && review.images.length > 0 && (
          <ul className='product-review__images'>
            {review.images.map((image, i) => (
              <li key={i}>
                <img
                  className='img-fluid'
                  onClick={() => toggleModalHandler({ url: image, id: review.id })}
                  src={image.sizes.thumb}
                />
              </li>
            ))}
          </ul>
        )}
        <label className='product-review__likes'>
          Found this review helpful?{' '}
          <span onClick={toggleLikeHandler} className={isLiked ? 'product-review__likes--liked' : ''}>
            <i className='fa fa-thumbs-up'></i>
            {reviewLikes > 0 && <b>{reviewLikes}</b>}
          </span>
        </label>
      </div>

      {showLoginModal && (
        <LoginModal defaultShown ref={loginModalRef} className='plum-modal' dismissBtnText='Cancel' />
      )}
    </React.Fragment>
  );
};

ProductReviewsItem.defaultProps = {
  imagesShown: false,
};

export default memo(ProductReviewsItem);
